import React, {useContext} from "react";
import style from "./InfoPage.module.scss";
import { getMessage, Message, MessageContext } from "@messageformat/react";

const ContactAppendix = () => {
  const messageContext = useContext(MessageContext);

  return (
    <div className={style.contactAppendix}>
      <h2>
        <Message id="contactAppendix.title" />
      </h2>
      <div dangerouslySetInnerHTML={{__html: getMessage(messageContext, "contactAppendix.description")() }} />
      <p dangerouslySetInnerHTML={{__html: getMessage(messageContext, "contactAppendix.description2")() }} />
      <a href="/kontakt" className={style.contactAppendixCta}>
        <Message id="contactAppendix.cta" />
      </a>
    </div>
  );
};

export default ContactAppendix;
